package org.multipaz.wallet.shared

class WalletBackendVerificationLinkExpiredException(message: String? = null): WalletBackendException(message)
